<div class="lines" [style.width]="(hours.length * 60 * unit + 1)+ 'px'">
  <sc-flex stretchContent fitHeight>
    @for (hour of hours; track hour) {
      <div class="line"></div>
      <div class="label-spacer" [style.min-width]="((60 * unit) -1) + 'px'"> </div>
    }
    <div class="line"></div>
  </sc-flex>
</div>
